module.exports = __webpack_public_path__ + "static/img/stay-option-icon-dryer.0880b2a3.svg";